import React from "react";

import CodeMirror from "@uiw/react-codemirror";

function ManuscriptTextEditorHost({
    editorRef,
    editorContent,
    extensions,
    basicSetup,
    selection,
    onOpenReviewContextMenu,
    onEditorChange,
    onUpdate,
}) {
    return (
        <div
            style={{ height: "100%" }}
            onContextMenu={(event) => {
                if (!selection?.hasSelection) return;
                const editorElement = event.target.closest?.(".cm-editor");
                if (!editorElement) return;
                event.preventDefault();
                onOpenReviewContextMenu?.({
                    top: event.clientY,
                    left: event.clientX,
                });
            }}
        >
            <CodeMirror
                ref={editorRef}
                className="manuscript-codemirror"
                style={{ height: "100%" }}
                value={editorContent}
                height="100%"
                extensions={extensions}
                basicSetup={basicSetup}
                onUpdate={onUpdate}
                onChange={(value, viewUpdate) => {
                    onEditorChange(value, viewUpdate.state.selection.main.head);
                }}
            />
        </div>
    );
}

export default ManuscriptTextEditorHost;
